import React from 'react';
import PropTypes from 'prop-types';
import { BasicPrice } from './subcomponents/BasicPrice';
import { StrikeThroughPrice } from './subcomponents/StrikeThroughPrice';
import { BasicPerItemPrice } from './subcomponents/BasicPerItemPrice';
import { StrikeThrougPerItemPrice } from './subcomponents/StrikeThroughPerItemPrice';
import { isBasicPerItemPrice, isStrikeThroughPerItemPrice, isStrikeThroughPrice } from '../../utils/utils';

export const PriceMinimal = ({ skuModel, quantity, align }) => {
  const totalPrice = skuModel._product.pricing.cartItem.total;
  if (isBasicPerItemPrice(skuModel, quantity)) {
    const unitPrice = skuModel._product.pricing.value
      ? skuModel._product.pricing.value
      : skuModel._product.pricing.original;
    return <BasicPerItemPrice totalPrice={totalPrice} unitPrice={unitPrice} align={align} />;
  }
  if (isStrikeThroughPrice(skuModel, quantity)) {
    const unitPrice = skuModel._product.pricing.original;
    const percentOffValue = skuModel._product.pricing.promotion.percentageOff;
    const message = skuModel._product.pricing.promotion.message;
    return (
      <StrikeThroughPrice
        totalPrice={totalPrice}
        unitPrice={unitPrice}
        percentOffValue={percentOffValue}
        percentOffMessage={message}
        align={align}
      />
    );
  }
  if (isStrikeThroughPerItemPrice(skuModel, quantity)) {
    const originalUnitPrice = skuModel._product.pricing.original;
    const discountUnitPrice = skuModel._product.pricing.value;
    const percentOffValue = skuModel._product.pricing.promotion.percentageOff;
    const percentOffMessage = skuModel._product.pricing.promotion.message;
    return (
      <StrikeThrougPerItemPrice
        totalPrice={totalPrice}
        originalUnitPrice={originalUnitPrice}
        discountUnitPrice={discountUnitPrice}
        percentOffValue={percentOffValue}
        percentOffMessage={percentOffMessage}
        align={align}
      />
    );
  }
  return <BasicPrice totalPrice={totalPrice} align={align} />;
};

PriceMinimal.propTypes = {
  /**
   * the transformed price data
   */
  skuModel: PropTypes.shape({
    _product: PropTypes.shape({
      pricing: PropTypes.shape({
        itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

        // unit price
        original: PropTypes.number.isRequired,

        // discount unit price
        value: PropTypes.number,

        // when true, display exchange pricing badge
        showExchangePricing: PropTypes.bool,

        // when true, display preferred pricing badge
        showPreferredPricingBadge: PropTypes.bool,

        // when true, display preferred pricing badge's tooltip
        showPreferredPricingBadgeToolTip: PropTypes.bool,

        cartItem: PropTypes.shape({

          // total price of this line-item
          total: PropTypes.number.isRequired,
        }),

        promotion: PropTypes.shape({
          // used to display %off message
          message: PropTypes.string,

          // % off when have discount
          percentageOff: PropTypes.string,
        }),
        dates: PropTypes.shape({
          // start date of discount
          start: PropTypes.string,

          // end date of discount
          end: PropTypes.string
        })
      }).isRequired
    }).isRequired,
  }).isRequired,
  quantity: PropTypes.number.isRequired,
  align: PropTypes.string
};

PriceMinimal.defaultProps = {
  align: 'start'
};

PriceMinimal.displayName = 'PriceMinimal';
